<template>
    <div class="content-wrap"
         :class="{ 'no-scroll' : ! listScrollable }"
         v-hammer:swipe.horizontal="changeCategory">
        <kapp-header id="mainHeader" :show-header="listScrollable"></kapp-header>

        <router-link :to="{name: $route.meta.createPost}" class="button button--primary button--new">Neuer post <i class="icon-bearbeiten"></i></router-link>


        <transition :name="animDirection">
            <transition-group :name="hideArticleEffect" tag="div" class="list list--article" :key="categoryFilter">
                <kapp-articleBlock v-for="article in filteredArticles" :available_categories="categories"
                                   :article="article"
                                   v-bind:key="'uid-' + article.uid"
                                   :uid="article.uid"
                                   :class="{ 'is-invisible' : article.fullView }"
                                   :layout="like_settings.target"
                                   :like_settings="like_settings" />
            </transition-group>
        </transition>


        <router-link :to="{name: $route.meta.createPost}" class="button-fixed"><i class="icon-bearbeiten"></i></router-link>
    </div>
</template>

<script>

    import KappNews from "../blocks/KappNews";
    import KappCategoryNav from './KappCategoryNav';
    import Header from '../layouts/Header';
    import debounce from 'lodash.debounce';
    import api, { ApiDefaults } from '../../utils/api_call';
    import { STORE_BULLETIN, STORE_BULLETIN_CATEGORIES } from '../../utils/store/actions/general';

    export default {
        name: "KappDashboardList",
        components: {
            'kapp-categories': KappCategoryNav,
            'kapp-articleBlock': KappNews,
            'kapp-header': Header
        },
        data() {
            return {
                categories: [],
                fullTextFilter: '',
                categoryFilter: '',
                listScrollable: true,
                categoriesVisible: true,
                animDirection: 'slide-left',
                hideArticleEffect: null,
                articles: this.$store.getters.bulletinItems,
                pageTitle: 'Schwarzes Brett',
                like_settings: {pid: this.$route.meta.uid, target: (this.$route.name === 'ImpressionList' ? 'impression' : 'bulletin')}
            };
        },

        methods: {
            track() {
                this.$ga.page('/aktuelles');
            },
            fetchData: debounce(function () {

                let sourceUid = this.$route.meta.uid;

                let apiParams = Object.assign({}, ApiDefaults, {method: 'get', params: {id: this.$route.meta.uid}});
                api(apiParams)
                    .then(( response ) => {
                        if ( response.status === 200 ) {
                            this.articles = [];
                            this.articles = response.data.news.content.map(( item ) => {

                                                        item.categories = [ parseInt(item.categories) ];
                                                        item.visible = true;

                                                        return item;
                                                    })
                                                    .sort(( a, b ) => {
                                                        return b.datetime - a.datetime;
                                                    });
                            this.categories = Object.values(response.data.news.categories);
                            Events.$emit('showCategories', this.categories);

                            if ( this.$route.name === 'AktuellesListe' ) { // Bulletin
                                this.$store.commit(STORE_BULLETIN, this.articles);
                                this.$store.commit(STORE_BULLETIN_CATEGORIES, this.categories);
                            }
                            else {

                            }

                        }
                    })
                    .catch(( err ) => {
                        console.warn(err.message);
                    })
                    .finally(() => this.hideArticleEffect = 'hideArticles');


            }, 125),

            lightbox: function ( evt ) {

                this.listScrollable = !evt.state;
                this.categoriesVisible = !evt.state;
                /*if ( evt.state ) {
                    this.$el.querySelector('.list--article').style.height = this.$el.scrollHeight + 'px';
                    this.articles = this.articles.map(( item ) => {
                        item.visible = (item.uid === evt.uid);
                        return item;
                    });
                    // _.map(this.articles, ( item ) => item.visible = (item.uid === evt.uid));
                }
                else {
                    this.fetchData();
                    this.$el.querySelector('.list--article').style.height = '';
                    this.articles = this.articles.map(( item ) => {
                        item.visible = true;
                        return item;
                    });
                    // _.map(this.articles, ( item ) => item.visible = true);
                }*/


            },
            switchCategory: function ( val ) {

                if ( val === '' ) {
                    this.animDirection = 'news-right';
                    val = 0;
                }
                else {
                    val = val.toString().split('-')[ 1 ];

                    if ( val < this.categoryFilter )
                        this.animDirection = 'news-right';

                    else
                        this.animDirection = 'news-left';
                }

                this.$nextTick(() => this.categoryFilter = parseInt(val));
            },
            changeCategory: function ( evt ) {
                // ignore header component
                if ( evt.target.classList.contains('header') ) return;

                let idx = this.categories.findIndex(function ( cat ) {
                    return cat.uid === this.categoryFilter;
                }.bind(this));

                if ( evt.type !== 'swipeleft' ) { // go left
                    if ( typeof this.categories[ idx - 1 ] !== 'undefined' ) {
                        Events.$emit('category:goto', 'cat-' + this.categories[ idx - 1 ].uid);
                        return;
                    }
                    else {
                        Events.$emit('category:goto', '');
                    }
                }
                else { // go right
                    if ( typeof this.categories[ idx + 1 ] !== 'undefined' ) {
                        Events.$emit('category:goto', 'cat-' + this.categories[ idx + 1 ].uid);
                        return;
                    }
                }
            }

        },
        computed: {
            filteredArticles: function () {
                let filter = this.fullTextFilter,
                    category = this.categoryFilter;

                return this.articles.filter(function ( art ) {
                    let textFound = true,
                        inCategory = true;

                    /** Text Search */
                    if ( this.filter ) textFound = art.title.toLowerCase().includes(this.filter);

                    /** Category search */


                    if ( this.category !== 0 && this.category !== '' ) {
                        inCategory = (art.categories.indexOf(this.category) !== -1);
                    }

                    return textFound && inCategory;

                }, {filter: filter, category: category});
            }
        },
        created() {
            this.fetchData();
            Events.$on('switchContentCategory', this.switchCategory);
            Events.$on('lightbox', this.lightbox);
        },
        mounted() {
            this.fetchData();
        }
    };
</script>

<style scoped>

    .button.button--new {
        margin-bottom: 15px;
        position: relative;
    }

    .button.button--new i[class*="icon-"] {
        position: absolute;
        top: 50%;
        right: 20px;
        transform: translateY(-50%);
    }

    .button-fixed {
        position: fixed;
        right: 0;
        bottom: 30px;
        background: #E4223C;
        color: #FFF;
        font-size: 20px;
        line-height: 1;
        padding: 14px 8px;
        padding-left: 20px;
        clip-path: polygon(0 50%, 20px 0, 100% 0, 100% 100%, 20px 100%, 0 50%);
    }
</style>



// WEBPACK FOOTER //
// src/components/subparts/KappDashboardList.vue